import { useParams } from "react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Container from "react-bootstrap/Container";
import CommonHeader from "../containers/CommonHeader";
import ProductWithQuestions from "../containers/ProductWithQuestions";
import { trackViewItem } from "../ducks/tracking";

export default function ProductScreen() {
  const dispatch = useDispatch();
  const params = useParams();
  const orderUuidEdit = params.orderUuid;
  const productId = parseInt(params.productId, 10);
  const product = useSelector((state) =>
    state.products.items.find((p) => p.id === productId),
  );
  const productFound = !!product;

  // Editar um item da sacola não é ver o produto de novo.
  React.useEffect(() => {
    if (productFound && !orderUuidEdit) {
      dispatch(trackViewItem(productId));
    }
  }, [dispatch, productId, productFound, orderUuidEdit]);

  if (!product) {
    return (
      <>
        <CommonHeader text="Detalhes do produto" />
        <Container className="text-center mt-3 mb-3">
          <h1>Ops...</h1>
          <p>Este produto não existe mais.</p>
        </Container>
      </>
    );
  }

  return (
    <ProductWithQuestions
      productId={productId}
      product={product}
      orderUuidEdit={orderUuidEdit}
    />
  );
}
